import { useState } from 'react';
import * as api from '../api/client.js';

export function CreateRoundDialog({
  onClose,
  onCreated,
}: {
  onClose: () => void;
  onCreated: (round: api.RoundSummary) => void;
}) {
  const [name, setName] = useState('');
  const [tempo, setTempo] = useState<'blitz' | 'normal' | 'slow'>('normal');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (): Promise<void> => {
    setError(null);
    setLoading(true);
    try {
      const round = await api.createRound({ name, tempo });
      onCreated(round);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'שגיאה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>יצירת משחק חדש</h2>
        <label>
          <span>שם המשחק</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="למשל: מלחמת החצרות"
            disabled={loading}
          />
        </label>

        <label>
          <span>מהירות</span>
          <div className="tempo-picker">
            <TempoOption
              label="ברק"
              desc="30 יום אמת • כל יום משחק = 72 שניות"
              active={tempo === 'blitz'}
              onClick={() => setTempo('blitz')}
            />
            <TempoOption
              label="רגיל"
              desc="3 חודשים אמת • יום משחק = 3.6 דקות"
              active={tempo === 'normal'}
              onClick={() => setTempo('normal')}
            />
            <TempoOption
              label="איטי"
              desc="6 חודשים אמת • יום משחק = 7.2 דקות"
              active={tempo === 'slow'}
              onClick={() => setTempo('slow')}
            />
          </div>
        </label>

        {error && <div className="error">{error}</div>}

        <div className="modal-actions">
          <button onClick={onClose} disabled={loading}>ביטול</button>
          <button className="primary" onClick={() => void submit()} disabled={loading || !name}>
            {loading ? '...' : 'צור'}
          </button>
        </div>
      </div>
    </div>
  );
}

function TempoOption({
  label,
  desc,
  active,
  onClick,
}: {
  label: string;
  desc: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <div className={`tempo-option ${active ? 'active' : ''}`} onClick={onClick}>
      <strong>{label}</strong>
      <div className="desc">{desc}</div>
    </div>
  );
}
